        <app-page-data-panel title="Attachments" [resultText]="attachments.length + ' files'">
            <div class="upload-strip" *ngIf="allowUpload">
                <input pInputText [(ngModel)]="attachmentType" placeholder="Attachment type" />
                <input pInputText [(ngModel)]="notes" placeholder="Notes" />
                <p-fileUpload mode="basic" chooseLabel="Upload Attachment" chooseIcon="pi pi-upload"
                    [disabled]="!documentType || !documentId || uploadProgress > 0"
                    [auto]="true" [customUpload]="true" (onSelect)="upload($event)"></p-fileUpload>
            </div>
            <p-progressBar *ngIf="uploadProgress > 0" [value]="uploadProgress"></p-progressBar>
            <div *ngIf="allowUpload && (!documentType || !documentId)" class="upload-hint">
                Save the draft first to attach supporting files.
            </div>
            <div *ngIf="attachments.length; else noAttachments" class="attachment-list">
                <div class="attachment-row" *ngFor="let attachment of attachments">
                    <div>
                        <strong>{{ attachment.fileName || 'Attachment' }}</strong>
                        <span>{{ attachment.uploadedAt | date:'short' }} {{ attachment.uploadedBy ? ('by ' + attachment.uploadedBy) : '' }}</span>
                    </div>
                    <div class="attachment-actions">
                        <p-button *ngIf="attachment.fileUrl" label="Open" icon="pi pi-external-link" [outlined]="true" size="small" (click)="open(attachment.fileUrl)"></p-button>
                        <p-button *ngIf="allowUpload && attachment.attachmentId" icon="pi pi-trash" severity="danger" [text]="true" size="small" (click)="deleteAttachment(attachment)"></p-button>
                    </div>
                </div>
            </div>
            <ng-template #noAttachments>
                <div class="empty-state">
                    <i class="pi pi-paperclip"></i>
                    <span>No accounting attachments are available yet.</span>
                </div>
            </ng-template>
        </app-page-data-panel>
    

